export default "__VITE_ASSET__SX4V0sy$__"